import React, { Fragment, useRef } from "react";
import { StyleSheet, View } from "react-native";
import * as yup from "yup";
import { Formik } from "formik";
import useNavigationParam from "lib/use-navigation-param";
import useCustomBack from "lib/use-custom-back";
import SubmitErrorHandler from "lib/on-submit-error-handler";
import {
  TextInput,
  FileUploadInput,
  SecondaryButton,
  Scaffold,
} from "components";
import { useNavigation } from "@react-navigation/native";
import { getValuesWithUploadMechanism, updateProduct } from "./utils";
import useUploadProgress from "lib/use-upload-progress";
import { Product } from "models";
import { DataStore } from "@aws-amplify/datastore";
import fixNull from "lib/fix-null";

export default function ProductCECertification() {
  const manufacturerId = useNavigationParam("manufacturerId");
  const id = useNavigationParam("id");
  const ceNumber = useNavigationParam("ceNumber") || "";
  const ceDocLink = useNavigationParam("ceDocLink");
  const customBack = useCustomBack();
  const isSubmitting = useRef(false);
  const navigation = useNavigation();
  const [Upload, setProgress] = useUploadProgress();

  return (
    <Scaffold bottom>
      <Formik
        validationSchema={validatorSchema}
        initialValues={{
          ceNumber: fixNull(ceNumber),
          ceDocLink: fixNull(ceDocLink),
          hasNoCe: null,
        }}
        onSubmit={async (values) => {
          if (isSubmitting.current === false) {
            isSubmitting.current = true;
            const product = await DataStore.query(Product, id);
            const result = await getValuesWithUploadMechanism(
              manufacturerId,
              product,
              values.hasNoCe
                ? { ceDocLink: null, ceNumber: null, hasNoCe: true }
                : values,
              ["ceDocLink"],
              setProgress
            );

            isSubmitting.current = false;
            updateProduct(product, result, manufacturerId, navigation);
          }
        }}
      >
        {({ submitForm, setFieldValue }) => {
          customBack(submitForm);
          return (
            <Fragment>
              <TextInput
                name="ceNumber"
                multiline={false}
                placeholder="Enter a CE license number"
              />
              <FileUploadInput name="ceDocLink" />
              <SubmitErrorHandler />
              {Upload}
            </Fragment>
          );
        }}
      </Formik>
    </Scaffold>
  );
}

const validatorSchema = yup.object().shape({
  ceNumber: yup.string().nullable(),
  ceDocLink: yup.string().nullable(),
  hasNoCe: yup.boolean().nullable(),
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 40,
    backgroundColor: "white",
  },
  pickerButton: {
    paddingVertical: 30,
  },
});
